module.exports = __webpack_public_path__ + "img/smooth-country.0127d1e0.png";